import { defineMessages } from 'react-intl';

import { FREIGHT_NOTIFICATION_TYPE } from '../../../../types/freight-responses';

import type { FreightNotificationType } from '../../../../types/freight-responses';
import type { MessageDescriptor } from 'react-intl';

export const notificationsSectionMessages = defineMessages({
  sectionTitle: {
    defaultMessage: 'Shipment Alerts',
    id: 'e12Wtb',
    description: 'Toggle label for the freight shipment email notifications section',
  },
  description: {
    defaultMessage: "Notify recipients by email when this shipment's status changes",
    id: '9k6PQg',
    description: 'Explanation of what enabling shipment notifications does',
  },
  helperText: {
    defaultMessage: 'To add more than one recipient, separate each email address with a comma.',
    id: 'z7omD9',
    description: 'Hint explaining how to enter multiple recipient email addresses',
  },
  emailColumnHeader: {
    defaultMessage: 'Recipient Email',
    id: 'eFmGS+',
    description: 'Column header for the notification recipient email addresses',
  },
  updatesColumnHeader: {
    defaultMessage: 'Shipment Updates',
    id: 'irMhT5',
    description: 'Column header for the shipment status updates a recipient is subscribed to',
  },
  addRecipient: {
    defaultMessage: '+ Add Recipient',
    id: 'Yggw+c',
    description: 'Button label to add another notification recipient row',
  },
  removeRecipient: {
    defaultMessage: 'Remove recipient',
    id: 'eUeIyQ',
    description: 'Accessible label for the button that deletes a notification recipient row',
  },
  emailPlaceholder: {
    defaultMessage: 'Enter email address',
    id: 'tHpw4A',
    description: 'Placeholder for the notification recipient email input',
  },
  removeEmail: {
    defaultMessage: 'Remove {email}',
    id: 'eLYgEh',
    description: 'Accessible label for the remove button on a notification recipient email pill',
  },
  invalidEmailError: {
    defaultMessage: 'Enter a valid email address',
    id: 'F1cBXW',
    description: 'Validation message when a typed notification recipient address is not a valid email',
  },
  noEmailsError: {
    defaultMessage: 'Enter at least one recipient email',
    id: 'vPAeeL',
    description: 'Validation message when a notification row has updates selected but no email address',
  },
  noUpdatesError: {
    defaultMessage: 'Select at least one update',
    id: '3dvhDp',
    description: 'Validation message when a notification row has an email address but no updates selected',
  },
  maxEmailsError: {
    defaultMessage: '5 email addresses maximum',
    id: 'nTZKOw',
    description: 'Error shown when a notification group reaches the maximum number of email addresses',
  },
  quoteReady: {
    defaultMessage: 'Quote Ready',
    id: 'AM+6Do',
    description: 'Shipment update label for when a freight quote becomes available',
  },
  exception: {
    defaultMessage: 'Exception',
    id: 'RPnlcc',
    description: 'Shipment update label for when a delivery exception occurs',
  },
  booked: {
    defaultMessage: 'Booked',
    id: 'lwRbMy',
    description: 'Shipment update label for when the shipment is booked with the carrier',
  },
  delivered: {
    defaultMessage: 'Delivered',
    id: 'TOZCcF',
    description: 'Shipment update label for when the shipment is delivered',
  },
  inTransit: {
    defaultMessage: 'In Transit',
    id: '7gSj/0',
    description: 'Shipment update label for when the shipment is in transit',
  },
  outForDelivery: {
    defaultMessage: 'Out for Delivery',
    id: 'jQW79z',
    description: 'Shipment update label for when the shipment is out for delivery',
  },
  pickupScheduled: {
    defaultMessage: 'Pickup Scheduled',
    id: '/9gcz7',
    description: 'Shipment update label for when the carrier pickup is scheduled',
  },
  voided: {
    defaultMessage: 'Voided',
    id: 'y4kWrb',
    description: 'Shipment update label for when the shipment is voided',
  },
});

export const NOTIFICATION_TYPE_OPTIONS: { value: FreightNotificationType; label: MessageDescriptor }[] = [
  { value: FREIGHT_NOTIFICATION_TYPE.QuoteReady, label: notificationsSectionMessages.quoteReady },
  { value: FREIGHT_NOTIFICATION_TYPE.Booked, label: notificationsSectionMessages.booked },
  { value: FREIGHT_NOTIFICATION_TYPE.PickupScheduled, label: notificationsSectionMessages.pickupScheduled },
  { value: FREIGHT_NOTIFICATION_TYPE.InTransit, label: notificationsSectionMessages.inTransit },
  { value: FREIGHT_NOTIFICATION_TYPE.OutForDelivery, label: notificationsSectionMessages.outForDelivery },
  { value: FREIGHT_NOTIFICATION_TYPE.Delivered, label: notificationsSectionMessages.delivered },
  { value: FREIGHT_NOTIFICATION_TYPE.Exception, label: notificationsSectionMessages.exception },
  { value: FREIGHT_NOTIFICATION_TYPE.Voided, label: notificationsSectionMessages.voided },
];
